export default __webpack_public_path__ + "static/media/image13.c454711b.svg";